import * as React from 'react';

function SvgCloudsFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M11.473 9a4.5 4.5 0 00-8.72-.99A3 3 0 003 14h8.5a2.5 2.5 0 10-.027-5z' />
			<path d='M14.544 9.772a3.506 3.506 0 00-2.225-1.676 5.502 5.502 0 00-6.337-4.002 4.002 4.002 0 017.392.91 2.5 2.5 0 011.17 4.769z' />
		</svg>
	);
}

export default SvgCloudsFill;
